//____ ANCHOR LINKS ANIMATIONS ____ //
//____ AUTHOR: LUBOMÍR BLAŽEK ____ //
function nl_fn_anchor_link() {
    var anchor_link = $("a[href^='#anchor-']");
    anchor_link.on("click", function (e) {
        var id = $(this).attr("href");
        if ($(id).length) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $(id).offset().top - 5
            }, 500);
        }
    });
    if(window.location.hash) {
        if ($(window.location.hash).length) {
            $('html, body').animate({
                scrollTop: $(window.location.hash).offset().top - 5
            }, 0);
        }
    }
    $(document).on('click', '[data-attr-scroll]', function (event) {
        event.preventDefault();

        var anchor = $(this).attr('data-attr-scroll');

        $('html,body').animate({
            scrollTop: $('#' + anchor).offset().top - ($('#main_header').height())
        }, 500);
    });


    var $hash = window.location.hash,
        $anchor_elm = $("[data-anchor-elm]");
    $anchor_elm.each(function(){
        if($hash && $(this).data("anchor-elm") == $hash.replace('#','')) {
            var $anchor_elm = $("[data-anchor-elm="+$hash.replace('#','')+"]");

            $('html, body').animate({
                scrollTop: $anchor_elm.offset().top - 115
            }, 0);
        }
    });
}